/**
 * stores.js — trang Hệ thống cửa hàng (mục 29): lọc theo thành phố + ô tìm (bỏ dấu),
 * chọn cửa hàng đồng bộ giữa danh sách và ghim bản đồ, trạng thái "Đang mở cửa" tính
 * theo giờ hiện tại, nút "Gần tôi" dùng định vị của trình duyệt.
 *
 * Markup: [data-store-finder] chứa
 *   [data-store-search]            ô tìm
 *   [data-store-city="slug"]       chip thành phố (aria-pressed)
 *   [data-store-near]              nút "Gần tôi"
 *   li[data-store][data-city][data-open][data-close][data-lat][data-lng]
 *       > [data-store-select] (nút chọn) · [data-store-num] · [data-store-dist] · [data-store-status]
 *   [data-store-pin]               ghim — thứ tự TRÙNG thứ tự <li> (PHP in hai vòng cùng một query)
 *   [data-store-empty]             chỗ in thông báo không có kết quả
 *
 * Giờ mở cửa so với giờ VIỆT NAM (UTC+7) chứ không phải giờ máy người xem: khách ở
 * nước ngoài đặt quà về nhà vẫn thấy đúng cửa hàng đang mở hay đóng.
 *
 * WP: giữ file này (trang tĩnh do PHP in, JS chỉ lọc/chọn); khi gắn bản đồ thật thì
 * thay phần .store-map bằng Google Maps / Mapbox và gọi select() từ sự kiện click marker.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var VN_OFFSET = 7 * 60; // phút
    var root = document.querySelector('[data-store-finder]');
    if (!root) return;

    var search = root.querySelector('[data-store-search]');
    var cities = [].slice.call(root.querySelectorAll('[data-store-city]'));
    var near = root.querySelector('[data-store-near]');
    var items = [].slice.call(root.querySelectorAll('[data-store]'));
    var pins = [].slice.call(root.querySelectorAll('[data-store-pin]'));
    var results = root.querySelector('[data-store-results]');
    var empty = root.querySelector('[data-store-empty]');

    var city = (cities.filter(function (b) {
        return b.getAttribute('aria-pressed') === 'true';
    })[0] || cities[0]).getAttribute('data-store-city');
    var active = Math.max(0, items.map(function (li) {
        return li.classList.contains('is-active');
    }).indexOf(true));

    function toast(text, icon) {
        if (window.WBToast) window.WBToast.show(text, { icon: icon || '' });
    }

    // "Cầu Giấy" khớp "cau giay": bỏ dấu tổ hợp sau NFD, riêng đ/Đ không tách dấu được
    function fold(text) {
        var s = String(text || '').toLowerCase();
        if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
        return s.replace(/đ/g, 'd').replace(/\s+/g, ' ').trim();
    }

    function cityLabel(slug) {
        var button = cities.filter(function (b) {
            return b.getAttribute('data-store-city') === slug;
        })[0];
        return button ? button.textContent.trim() : '';
    }

    function haystack(li) {
        if (!li._hay) {
            li._hay = fold([
                li.querySelector('.store-item__name').textContent,
                li.querySelector('.store-item__addr').textContent,
                cityLabel(li.getAttribute('data-city'))
            ].join(' '));
        }
        return li._hay;
    }

    function matches(li, query) {
        return !query || haystack(li).indexOf(query) !== -1;
    }

    // ----- Trạng thái mở cửa -----
    function minutes(hhmm) {
        var parts = String(hhmm || '').split(':');
        return parseInt(parts[0], 10) * 60 + (parseInt(parts[1], 10) || 0);
    }

    function nowInVietnam() {
        var d = new Date();
        return (d.getUTCHours() * 60 + d.getUTCMinutes() + VN_OFFSET) % (24 * 60);
    }

    function isOpen(li, now) {
        var open = minutes(li.getAttribute('data-open'));
        var close = minutes(li.getAttribute('data-close'));
        if (isNaN(open) || isNaN(close)) return false;
        // Đóng sau nửa đêm (vd 18:00 – 02:00): mở khi đã qua giờ mở HOẶC chưa tới giờ đóng
        return close > open ? now >= open && now < close : now >= open || now < close;
    }

    function paintStatus() {
        var now = nowInVietnam();
        items.forEach(function (li) {
            var badge = li.querySelector('[data-store-status]');
            if (!badge) return;
            var open = isOpen(li, now);
            badge.textContent = open ? 'Đang mở cửa' : 'Đã đóng cửa';
            badge.classList.toggle('badge--success', open);
            badge.classList.toggle('badge--muted', !open);
        });
    }

    // ----- Lọc + đánh số + chọn -----
    function visible() {
        return items.filter(function (li) {
            return !li.hidden;
        });
    }

    function paintActive() {
        items.forEach(function (li, i) {
            var on = i === active && !li.hidden;
            li.classList.toggle('is-active', on);
            li.querySelector('[data-store-select]').setAttribute('aria-pressed', on ? 'true' : 'false');
            if (pins[i]) pins[i].classList.toggle('is-active', on);
        });
    }

    function apply() {
        var query = fold(search ? search.value : '');
        var n = 0;

        items.forEach(function (li, i) {
            var show = li.getAttribute('data-city') === city && matches(li, query);
            li.hidden = !show;
            if (pins[i]) pins[i].hidden = !show;
            if (!show) return;
            // Số thứ tự đếm lại trong thành phố đang xem: danh sách và ghim cùng số
            n += 1;
            [li.querySelector('[data-store-num]'), pins[i] && pins[i].querySelector('[data-store-num]')].forEach(function (el) {
                if (el) el.textContent = String(n);
            });
        });

        var shown = visible();
        if (shown.length && items[active].hidden) active = items.indexOf(shown[0]);
        paintActive();
        paintEmpty(shown.length, query);
    }

    // Không có kết quả trong thành phố đang chọn nhưng thành phố khác có: đưa sẵn nút chuyển
    function paintEmpty(count, query) {
        if (!empty) return;
        empty.hidden = count > 0;
        if (count) return;

        var others = {};
        items.forEach(function (li) {
            var c = li.getAttribute('data-city');
            if (c !== city && matches(li, query)) others[c] = (others[c] || 0) + 1;
        });

        var html = '<p>Không có cửa hàng nào khớp “' + escapeHtml(search.value.trim()) + '” tại ' + escapeHtml(cityLabel(city)) + '.</p>';
        Object.keys(others).forEach(function (c) {
            html += '<button class="btn btn--link" type="button" data-store-goto="' + c + '">Xem ' + others[c] +
                ' cửa hàng ở ' + escapeHtml(cityLabel(c)) + '<i class="ph-bold ph-arrow-right" aria-hidden="true"></i></button>';
        });
        empty.innerHTML = html;
    }

    function escapeHtml(value) {
        return String(value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    function setCity(slug) {
        city = slug;
        cities.forEach(function (b) {
            b.setAttribute('aria-pressed', b.getAttribute('data-store-city') === slug ? 'true' : 'false');
        });
        active = -1;
        items.some(function (li, i) {
            if (li.getAttribute('data-city') === slug) {
                active = i;
                return true;
            }
            return false;
        });
        if (active < 0) active = 0;
        apply();
    }

    // Khung danh sách tự cuộn (desktop 420px): đưa mục vừa chọn từ ghim vào tầm nhìn
    // bằng scrollTop của chính khung — scrollIntoView sẽ kéo cả trang theo.
    function reveal(li) {
        if (!results || results.scrollHeight <= results.clientHeight) return;
        var top = li.offsetTop;
        var bottom = top + li.offsetHeight;
        if (top < results.scrollTop) results.scrollTop = top;
        else if (bottom > results.scrollTop + results.clientHeight) results.scrollTop = bottom - results.clientHeight;
    }

    function select(index, fromMap) {
        if (index < 0 || !items[index] || items[index].hidden) return;
        active = index;
        paintActive();
        if (fromMap) reveal(items[index]);
    }

    // ----- Gần tôi -----
    function distanceKm(lat1, lng1, lat2, lng2) {
        var rad = Math.PI / 180;
        var dLat = (lat2 - lat1) * rad;
        var dLng = (lng2 - lng1) * rad;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function formatKm(km) {
        return (km < 10 ? km.toFixed(1) : String(Math.round(km))).replace('.', ',') + ' km';
    }

    function locate() {
        if (!navigator.geolocation) {
            toast('Trình duyệt không hỗ trợ định vị — hãy chọn thành phố để xem cửa hàng gần bạn.', 'ph-bold ph-map-pin');
            return;
        }
        near.setAttribute('aria-busy', 'true');
        navigator.geolocation.getCurrentPosition(
            function (pos) {
                near.removeAttribute('aria-busy');
                var best = -1;
                var bestKm = Infinity;
                items.forEach(function (li, i) {
                    var km = distanceKm(pos.coords.latitude, pos.coords.longitude,
                        parseFloat(li.getAttribute('data-lat')), parseFloat(li.getAttribute('data-lng')));
                    var dist = li.querySelector('[data-store-dist]');
                    if (dist) dist.textContent = formatKm(km);
                    if (km < bestKm) {
                        bestKm = km;
                        best = i;
                    }
                });
                if (best < 0) return;
                if (search) search.value = '';
                setCity(items[best].getAttribute('data-city'));
                select(best, true);
                toast('Gần bạn nhất: ' + items[best].querySelector('.store-item__name').textContent + ' · ' + formatKm(bestKm), 'ph-fill ph-map-pin');
            },
            function () {
                near.removeAttribute('aria-busy');
                // Bị từ chối quyền / hết thời gian / trang không chạy https: nói rõ lý do và lối thay thế
                toast('Chưa lấy được vị trí — hãy cho phép trình duyệt truy cập vị trí (trang cần https), hoặc chọn thành phố bên trên.', 'ph-bold ph-map-pin');
            },
            { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
        );
    }

    // ----- Sự kiện -----
    cities.forEach(function (button) {
        button.addEventListener('click', function () {
            setCity(button.getAttribute('data-store-city'));
        });
    });

    if (search) {
        search.addEventListener('input', apply);
        search.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                search.value = '';
                apply();
            }
        });
    }

    if (near) near.addEventListener('click', locate);

    // Bấm bất kỳ đâu trong mục (trừ link Chỉ đường / Gọi) cũng chọn cửa hàng
    root.addEventListener('click', function (event) {
        var go = event.target.closest('[data-store-goto]');
        if (go) {
            setCity(go.getAttribute('data-store-goto'));
            return;
        }
        var pin = event.target.closest('[data-store-pin]');
        if (pin) {
            select(pins.indexOf(pin), true);
            return;
        }
        if (event.target.closest('a')) return;
        var li = event.target.closest('[data-store]');
        if (li) select(items.indexOf(li), false);
    });

    paintStatus();
    apply();
    // Cập nhật mỗi phút: trang để mở qua giờ đóng cửa thì badge tự đổi
    window.setInterval(paintStatus, 60 * 1000);
})();
